import { get, post } from "../GenericServices";

const InvokeJob = {
  getJobsList: () => {
    return get("invoke-job/list-jobs");
  },
  executeJob: (executeEndpoint) => {
    return post(`${executeEndpoint}`);
  },
};

export default InvokeJob;
